import type { WidgetV2DetailVariant } from '../../layout-variants'
import commonCss from './common.css?inline'
import boxTemplate from './box/template.html?raw'
import boxCss from './box/style.css?inline'
import horizontalTemplate from './horizontal/template.html?raw'
import horizontalCss from './horizontal/style.css?inline'

export function getDetailTemplate(variant: WidgetV2DetailVariant): string {
  if (variant === 'box') return boxTemplate
  return horizontalTemplate
}

export function getDetailCss(variant: WidgetV2DetailVariant): string {
  if (variant === 'box') return `${commonCss}\n${boxCss}`
  return `${commonCss}\n${horizontalCss}`
}
